import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../authConfig";

export const msalInstance = new PublicClientApplication(msalConfig);

let pendingTokenRequest = null;

export function getAccessToken() {
  if (!pendingTokenRequest) {
    const account = msalInstance.getAllAccounts()[0];
    pendingTokenRequest = msalInstance
      .acquireTokenSilent({
        scopes: [import.meta.env.VITE_AZUREAD_CLIENTID],
        account,
      })
      .finally(() => {
        pendingTokenRequest = null;
      });
  }
  return pendingTokenRequest;
}